export const TEXTS = {
  ALL_CLIENTS: "All Client Types",
  ALL_FOR: "All for:",
  ALL_OEMS: "All OEMs",
  HEADER_CLIENT: "Client Type",
  HEADER_OEM: "OEM",
  HEADER_PLATFORM: "Platform",
  NO_VALUE: "No defined target",
};
